var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"text-center h-full overflow-hidden",attrs:{"flat":"","height":_vm.height,"width":_vm.width,"max-height":_vm.maxHeight,"max-width":_vm.maxWidth}},[_vm._v(" "+_vm._s(_vm.value.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }